import React, { useContext, useRef, useState } from "react";
import "./styles.css";
import { enviarSolicitacaoDeAporte, handleDocumentoUpload, handleHide } from "./functions";

import { Dados } from "../../../pages/Cliente/AporteSaque/AporteSaque";
import { Button } from "../../Button";
import { Input } from "../../Input";
import { LoadingButton } from "../../loadingButtom";
import { MensagemDeErro } from "../../RespostasDosFormularios/MensagemDeErro";
import { MensagemDeSucesso } from "../../RespostasDosFormularios/Sucesso";
import { ModalDesconectar } from "../ModalDesconectar";

import Modal from "react-bootstrap/Modal";
import { transformarValorParaBRLEmInput, transformarValorParaUSDEmInput } from "../../../functions/MascarasMonetarias";
import { ServicoFinanceiroClienteContext, usuarioServicoFinanceiroContextType } from "../../../context/servicoFinanceiroCliente";

interface modalProps {
  modal: boolean;
  setModal: (modal: boolean) => void;
  dadosUsuario: Dados;
}

export const ModalAporte = ({ modal, setModal, dadosUsuario }: modalProps) => {
  const filesElement = useRef(null);

  const [valorAporte, setValorAporte] = useState<number>(0);
  const [imagensDocumentacao, setImagensDocumentacao] = useState<
    string | ArrayBuffer | null
  >();
  const [sucesso, setSucesso] = useState<boolean>(false);
  const [falha, setFalha] = useState<boolean>(false);
  const [mensagem, setMensagem] = useState<string>("");
  const [modalDesconectar, setModalDesconectar] = useState<boolean>(false);

  const [valorAporteMask, setValorAporteMask] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);

  const { usuarioServicoFinanceiro } = useContext<usuarioServicoFinanceiroContextType>(ServicoFinanceiroClienteContext);
  const isUSD = usuarioServicoFinanceiro.idServicoFinanceiro === 3;

  const parseCurrencyValue = (formattedValue: string) => {
    const normalizedValue = isUSD
      ? formattedValue.replace(/\s/g, "")
      : formattedValue.replace(/\./g, "").replace(/,/g, ".");

    return Number(normalizedValue);
  };

  const handleValorAporteChange = (value: string) => {
    const formattedValue = isUSD
      ? transformarValorParaUSDEmInput(value, setValorAporteMask)
      : transformarValorParaBRLEmInput(value, setValorAporteMask);

    setValorAporte(parseCurrencyValue(formattedValue));
  };

  return !modalDesconectar ? (
    <Modal
      show={modal}
      onHide={() => handleHide(setModal, setSucesso, setFalha, setValorAporte, setValorAporteMask, setImagensDocumentacao)}
      className="aporte-saque-modal"
      centered
    >
      <form onSubmit={(e) => enviarSolicitacaoDeAporte(e, dadosUsuario, setLoading, valorAporte, imagensDocumentacao, setMensagem, setSucesso, setFalha, setValorAporte, setModalDesconectar, usuarioServicoFinanceiro)}>
        <Modal.Header closeButton>
          <Modal.Title>Aporte</Modal.Title>
        </Modal.Header>
        {falha && <MensagemDeErro mensagem={mensagem} />}
        {sucesso ? (
          <MensagemDeSucesso mensagem={mensagem} />
        ) : (
          <>
            <Modal.Body>
              <div className="aporte-saque-modal-body">
                <Input
                  label="Valor do aporte:"
                  maxLength={13}
                  autoComplete="off"
                  placeholder=" "
                  value={isUSD ? "$ " + valorAporteMask : "R$ " + valorAporteMask}
                  onChange={(e) => handleValorAporteChange(e.target.value)}
                />
                <div className="aporte-saque-bank-details">
                  <h6>Dados bancários</h6>
                  <span>Favorecido: Omega Consultoria e Negócios Ltda</span>
                  <span>Banco: Itaú Unibanco (341)</span>
                  <span>Agência: 8062</span>
                  <span>Conta: 98684-2</span>
                  <span>CNPJ: 34.365.211/0001-40</span>
                  <span>Chave PIX: contato@omegainvestimentos.com</span>
                </div>
                <div className="aporte-saque-upload-label">Comprovante de depósito</div>
                <div className="Area_DocumentosAnexos">
                  <Input
                    type="file"
                    multiple
                    ref={filesElement}
                    className="DocumentosAnexos_Botao"
                    accept="image/*,.pdf"
                    onChange={(e) => {
                      handleDocumentoUpload(e, setImagensDocumentacao);
                    }}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              {loading ? (
                <LoadingButton />
              ) : (
                <Button
                  classNameButton="btnAlterar"
                  onClick={(e) => enviarSolicitacaoDeAporte(e, dadosUsuario, setLoading, valorAporte, imagensDocumentacao, setMensagem, setSucesso, setFalha, setValorAporte, setModalDesconectar, usuarioServicoFinanceiro)}
                  titleButton="Confirmar"
                  disabled={sucesso ? true : false}
                  type="submit"
                />
              )}
              <Button
                classNameButton="btnCancelar"
                onClick={() => handleHide(setModal, setSucesso, setFalha, setValorAporte, setValorAporteMask, setImagensDocumentacao)}
                titleButton="Cancelar"
              />
            </Modal.Footer>
          </>
        )}
      </form>
    </Modal>
  ) : (
    <ModalDesconectar modal={modalDesconectar} />
  );
};
